import { FC } from "react";
import { useFuncTask } from "../../hooks/taskHooks/useFuncTask";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { TaskContext } from "../../contexts/TaskContext";


interface TaskProviderProps {
    children?: React.ReactNode;
}

const TaskProvider: FC<TaskProviderProps> = ({ children }) => {
    const { boardId, id } = useParams();
    const taskHooks = useFuncTask(boardId !== undefined ? Number(boardId) : undefined, id !== undefined ? Number(id) : undefined);

    return (
        <TaskContext.Provider value={{
            team: taskHooks.team,

            //Состояния загрузки
            isLoading: taskHooks.isLoading,
            setIsLoading: taskHooks.setIsLoading,

            //Основные данные задачи
            taskInformation: taskHooks.taskInformation,
            setTaskInformation: taskHooks.setTaskInformation,
            allPerson: taskHooks.allPerson,
            setAllPerson: taskHooks.setAllPerson,
            projectSettings: taskHooks.projectSettings,
            setProjectSettings: taskHooks.setProjectSettings,
            defaultBoardId: taskHooks.defaultBoardId,
            setDefaultBoardId: taskHooks.setDefaultBoardId,

            timeSelectVariant: taskHooks.timeSelectVariant,
            setTimeSelectVariant: taskHooks.setTimeSelectVariant,


            //Подзадачи
            subtasksHead: taskHooks.subtasksHead,
            setSubtasksHead: taskHooks.setSubtasksHead,
            subTasks: taskHooks.subTasks,
            setSubTasks: taskHooks.setSubTasks,
            allowedProjects: taskHooks.allowedProjects,
            setAllowedProjects: taskHooks.setAllowedProjects,

            //Чеклисты
            checklistGroups: taskHooks.checklistGroups,
            setCheklistGroups: taskHooks.setCheklistGroups,

            //История задачи
            taskHistory: taskHooks.taskHistory,
            setTaskHistory: taskHooks.setTaskHistory,
            taskHistoryFilters: taskHooks.taskHistoryFilters,
            setTaskHistoryFilters: taskHooks.setTaskHistoryFilters,
            historySkip: taskHooks.historySkip,
            setHistorySkip: taskHooks.setHistorySkip,
            haveMoreRecords: taskHooks.haveMoreRecords,
            setHaveMoreRecords: taskHooks.setHaveMoreRecords,
            viewHistory: taskHooks.viewHistory,
            setViewHistory: taskHooks.setViewHistory,

            fastTaskUpdate: taskHooks.fastTaskUpdate,

            //UI состояния
            tab: taskHooks.tab,
            setTab: taskHooks.setTab,
            locationHash: taskHooks.locationHash,
            setLocationHash: taskHooks.setLocationHash,
            editTask: taskHooks.editTask,
            setEditTask: taskHooks.setEditTask,
            forceLinkTerm: taskHooks.forceLinkTerm,
            forceLinkName: taskHooks.forceLinkName,
            forceLinkDescription: taskHooks.forceLinkDescription,
            forceLinkExecutor: taskHooks.forceLinkExecutor,

            //Права доступа
            userAccess: taskHooks.userAccess,
            setUserAccess: taskHooks.setUserAccess,

            //Референсы
            scrollComponentDiv: taskHooks.scrollComponentDiv,

            //Функции загрузки данных
            loadTaskInfo: taskHooks.loadTaskInfo,
            getAllTaskPerson: taskHooks.getAllTaskPerson,
            loadChecklist: taskHooks.loadChecklist,
            loadSubTasks: taskHooks.loadSubTasks,
            loadTaskHistory: taskHooks.loadTaskHistory,

            // Функции обновления данных
            updatePriority: taskHooks.updatePriority,
            updateType: taskHooks.updateType,
            addTags: taskHooks.addTags,
            removeTags: taskHooks.removeTags,
            onChangeCustomTime: taskHooks.onChangeCustomTime,
            selectTimeVariant: taskHooks.selectTimeVariant,

            //Функции UI взаимодействия
            changeTab: taskHooks.changeTab,
            onScroll: taskHooks.onScroll,

            //Вспомогательные значения
            currentPageBoardId: taskHooks.currentPageBoardId,
            defaultTab: taskHooks.defaultTab,
            checkList: taskHooks.checkList,

            // Быстрое обновление
            setPercentageCompletion: taskHooks.setPercentageCompletion,
            setRequiredTime: taskHooks.setRequiredTime,
            setDateStart: taskHooks.setDateStart,
            setDateEnd: taskHooks.setDateEnd,
            setExecutor: taskHooks.setExecutor,
            setGroup: taskHooks.setGroup,

            dateStart: taskHooks.dateStart,
            dateEnd: taskHooks.dateEnd,
            percentageCompletion: taskHooks.percentageCompletion,
            requiredTime: taskHooks.requiredTime,
            executor: taskHooks.executor,
            group: taskHooks.group,
            visibleGroup: taskHooks.visibleGroup,
            hiddenGroup: taskHooks.hiddenGroup,
            hasMore: taskHooks.hasMore,
            filteredChoiseExecutor: taskHooks.filteredChoiseExecutor,
            filteredChoiceGroup: taskHooks.filteredChoiceGroup,

            handleSelectExecutor: taskHooks.handleSelectExecutor,
            handleSelectGroup: taskHooks.handleSelectGroup,
            handleRemoveGroup: taskHooks.handleRemoveGroup,
            updatePercentageCompletion: taskHooks.updatePercentageCompletion,
            updateRequiredTime: taskHooks.updateRequiredTime,
            updateDate: taskHooks.updateDate
        }}>
            {children}
        </TaskContext.Provider>
    )
}

export default observer(TaskProvider);